<template>
  <div
    class="computer-drop"
    @dragover.prevent
    @drop.stop.prevent="onUploadFile($event, 'Drop')">
    <Spinner
      v-show="getLoaderState"
      :speed="1"
      size="huge"
      message="Loading..."
      class="position-absolute inner-Loader"/>
    <div class="computer-zone">
      <span class="computer-badge">
        <icon name="fileUpload"/>
      </span>
      <p class="computer-title">You can drag and drop file(s) to upload</p>
      <span class="computer-or">or</span>
      <label
        class="computer-browse"
        for="file-upload">
        Browse file
      </label>
      <input
        id="file-upload"
        class="computer-input"
        type="file"
        accept=".png,.jpg,.jpeg,.svg,.pdf"
        multiple
        @change="onUploadFile($event, 'Upload')">
      <span class="computer-hint">PNG, JPG, JPEG, SVG or PDF</span>
      <div
        v-if="formatError"
        class="upload-alert"
        role="alert">
        <icon name="alert-circle"/>
        <span>{{ formatError }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import EventBus from '@/EventBus';
import Vue from 'vue';
import Spinner from 'vue-simple-spinner';


export default {
  name:       'FileSelect',
  components: {
    Spinner,
  },
  data() {
    return {
      imageData:    null,
      loaderToggle: false,
      formatError:  '',
    };
  },
  computed: {
    getLoaderState() {
      return this.loaderToggle;
    },
  },
  methods: {
    formatFileName(name) {
      return name
        .replace(/[^a-zA-Z0-9._-]/g, '_')
        .replace(/_+/g, '_');
    },

    async onUploadFile(e, mood = 'Upload') {
      this.formatError = '';
      EventBus.$emit('showHideLoader', true);
      const target = mood === 'Upload' ? e.target : e.dataTransfer;

      try {
        const files = target.files;
        if (!files.length) { return; }

        this.totalFiles = files.length;
        this.$store.commit('activeProduct/updateTotalUploadFiles', this.totalFiles);
        this.$store.commit('activeProduct/updateCurrentUploadFile', 0);

        for (let i = 0; i < files.length; i++) {
          const originalFile = files[i];

          const formattedName = this.formatFileName(originalFile.name);
          const file          = new File([originalFile], formattedName, {
            type: originalFile.type,
          });

          const type          = file.type.split('/');
          const fileSize      = file.size / 1024 / 1024;
          const fileExtension = formattedName.split('.').pop().toLowerCase();

          const isValidPDF   = type[1] === 'pdf';
          const isValidImage = type[0] === 'image' && ['png', 'svg', 'jpg', 'jpeg'].includes(fileExtension);

          if (isValidPDF || isValidImage) {
            if (fileSize > 20) {
              alert(`"${formattedName}" is too large. Max allowed size is 20MB.`);
              this.$store.commit('activeProduct/updateCurrentUploadFile', i + 1);
              return;
            }
            let fileToUpload = file;

            if (isValidPDF) {
              fileToUpload = await this.handlePDFUpload(file);
            }

            this.getBase64(fileToUpload, type[1]);
          } else {
            this.formatError = `"${formattedName}" is not a valid image/pdf. Allowed: .png, .svg, .jpg, .jpeg, .pdf`;
            this.$store.commit('activeProduct/updateCurrentUploadFile', this.$store.getters['activeProduct/getCurrentUploadFile'] + 1);
            const totalUploFiles    = this.$store.getters['activeProduct/getTotalUploadFiles'];
            const currentUploadFile = this.$store.getters['activeProduct/getCurrentUploadFile'];
            if (totalUploFiles === currentUploadFile) {
              EventBus.$emit('showHideLoader', false);
              this.$store.commit('activeProduct/updateTotalUploadFiles', 0);
              this.$store.commit('activeProduct/updateCurrentUploadFile', 0);
            }
          }
        }
        target.value = ''; // Clear input after all
      } catch (ex) {
        EventBus.$emit('showHideLoader', false);
        this.formatError = ex.message;
      }
    },
    async handlePDFUpload(fileToUpload) {
      const reqFormData = new FormData();
      reqFormData.append('pdf', fileToUpload);
      const headers      = {
        'Content-Type': 'text/plain',
      };
      const res          = await axios.post('https://pdf-processing.bankmarketingcenter.com/node/pdf2svg/pdf2svg?return-svg=true', reqFormData, {
        headers,
        responseType: 'blob',
      })
        .catch((err) => {
          throw new Error(err.response.statusText);
        });
      const fileBlob     = await res.data;
      const rand         = Math.random().toString(36).slice(2, 7);
      const fileToReturn = new File([fileBlob], `pdf-${rand}.svg`, { lastModified: 1534584790000 });
      return Promise.resolve(fileToReturn);
    },
    getBase64(file, fileType) {
      const params = new URLSearchParams(window.location.search);
      const userId = params.get('userId') || '{00000000-0000-0000-0000-000000000000}';

      const imageData = {
        Id:                   '',
        Name:                 file.name,
        DefaultImageUrl:      '',
        ImageType:            'Image',
        CropOption:           'NotSpecified',
        ImageThumbnailPath:   '',
        ImageThumbnailPathV2: '',
      };

      const ext            = file.name.split('.').pop();
      const nameWithoutExt = file.name.replace(/\.[^/.]+$/, '');

      const formData = new FormData();
      formData.append('file', file);

      const serverURL = this.isSubdomain(this.$store.getters.getBMCInstance)
        ? this.$store.getters.getBMCInstance
        : `www.${this.$store.getters.getBMCInstance}`;

      axios.post(
        `https://${serverURL}.com/webservices/UploadImages.ashx?userId=${userId}`,
        formData,
      )
        .then((res) => {
          const url = res.data;

          imageData.Id       = url.split('#').pop();
          const returnedName = url.substring(url.lastIndexOf('/') + 1, url.lastIndexOf('#'));

          imageData.previousDefaultImageUrl =                `https://www.bankmarketingcenter.com/temp/uploadedimages/${imageData.Id}${nameWithoutExt}-resized-600.${ext}#${imageData.Id}`;

          imageData.ImageThumbnailPath =                ext === 'svg'
            ? url
            : `https://www.bankmarketingcenter.com/thumbnails/80-80--temp-uploadedimages-${returnedName}`;

          imageData.ImageThumbnailPathV2 = imageData.ImageThumbnailPath;
          imageData.DefaultImageUrl      = url.split('#')[0];

          EventBus.$emit('AddImageNewImageToMyGalleryImages', imageData);

          setTimeout(() => {
            EventBus.$emit('AddNewImageOnCanvas', imageData);
          }, 100);
        })
        .catch((e) => {
          throw new Error(e.message);
        });
    },

    isSubdomain(url) {
      url         = `https://${url}.com`;
      const regex = /^([a-z]+\:\/{2})?([\w-]+\.[\w-]+\.\w+)$/;
      return !!url.match(regex);
    },
  },
};

</script>
<style lang="scss" scoped>
.computer-drop {
  position: relative;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  font-family: 'Geist', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif;
  color: #14161B;
}

.computer-zone {
  position: relative;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 240px;
  padding: 40px;
  border: 1.5px dashed #D5D9E0;
  border-radius: 14px;
  background: #FBFBFC;
  text-align: center;
}

.computer-badge {
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: #EAF2FE;
  color: #0B57C2;
}

.computer-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.3;
  color: #14161B;
}

.computer-or {
  font-size: 13px;
  line-height: 1.3;
  color: #5E6573;
}

.computer-browse {
  height: 38px;
  min-height: 38px;
  min-width: 72px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 14px;
  border: 0;
  border-radius: 9px;
  background: #fff;
  color: #14161B;
  box-shadow: inset 0 0 0 1px #D5D9E0;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
}

.computer-browse:hover {
  background: #F3F4F6;
}

.computer-hint {
  font-size: 12.5px;
  line-height: 1.3;
  color: #5E6573;
}

.upload-alert {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 420px;
  margin-top: 4px;
  padding: 8px 12px;
  border-radius: 9px;
  background: #FEF3F2;
  box-shadow: inset 0 0 0 1px #FBC9C4;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  color: #912018;
  text-align: left;
}

.upload-alert ::v-deep .icon {
  min-width: 0;
  min-height: 0;
  flex-shrink: 0;
  color: inherit;
}

.upload-alert ::v-deep .icon svg {
  display: block;
  width: 15px;
  height: 15px;
}

.computer-input {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.computer-badge ::v-deep .icon {
  min-width: 0;
  min-height: 0;
  color: inherit;
}

.computer-badge ::v-deep .icon svg {
  display: block;
  width: 26px;
  height: 26px;
}

.inner-Loader {
  height: 430px;
  width: calc(100% - 80px);
  background: rgb(255, 255, 255);
  opacity: 0.9;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 56;
}
</style>
